module.exports = __webpack_public_path__ + "img/americano_old.aefba3fe.svg";